import { useQuery } from "@tanstack/react-query";
import { boardApi } from "../../api/board";

export const boardKeys = {
  all: ["board"] as const,
  notes: ["board", "notes"] as const,
};

export const useBoardNotes = (enabled: boolean = true) =>
  useQuery({
    queryKey: boardKeys.notes,
    queryFn: () => boardApi.getNotes(),
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 30_000,
    enabled,
  });
